import { LitElement, html, css, nothing } from 'lit-element';
import { when } from 'lit/directives/when.js';
import { KatapultButton } from '../../katapult-elements/katapult-button';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import SlTag from '@shoelace-style/shoelace/dist/components/tag/tag.js';
class ModelItemTag extends LitElement {
  static properties = {
    removable: { type: Boolean },
    tag: { type: Object },
    size: { type: String }
  };

  static styles = css`
    :host {
      display: contents;
    }
    sl-tag::part(base) {
      display: flex;
      gap: var(--sl-spacing-2x-small);
      background-color: var(--tag-background-color);
      border-color: var(--tag-border-color);
      color: var(--tag-color);
    }
    sl-tag::part(remove-button) {
      color: var(--tag-color);
    }
  `;

  render() {
    const { tag } = this;
    if (!tag) return nothing;

    return html`
      <sl-tooltip content=${tag.tooltip} .disabled=${!tag.tooltip} hoist>
        <sl-tag variant="neutral" .size=${this.size} pill .removable=${this.removable}>
          ${when(tag.icon, () => html`<katapult-icon icon=${tag.icon} size="14"></katapult-icon>`)}
          <span>${tag.name}</span>
        </sl-tag>
      </sl-tooltip>
    `;
  }

  constructor() {
    super();
    /** @type {SlTag['removable']} */
    this.removable = false;
    this.tag = null;
    /** @type {SlTag['size']} */
    this.size = 'small';
  }

  willUpdate(changedProperties) {
    if (changedProperties.has('tag')) {
      const color = this.tag?.color ?? 'var(--sl-color-neutral-500)';
      const borderColor = KatapultButton.GetBorderColor(color, this);
      const textColor = KatapultButton.GetTextColor(color, this);
      this.style.setProperty('--tag-background-color', color);
      this.style.setProperty('--tag-border-color', borderColor);
      this.style.setProperty('--tag-color', textColor);
    }
  }
}

customElements.define('model-item-tag', ModelItemTag);
